import React from 'react'
import { Modal, Button } from 'syngenta-react-components'
import { useForm } from 'react-hook-form'
import clear from '../../../assets/icons/clear.svg'
import { patchUser } from '../../../services/apiHelper'

const UpdateUserForm = ({ showModal, setShowModal, userInfo, getUser }) => {
  
  const { register, handleSubmit, reset, errors } = useForm({
    defaultValues: {
      ...userInfo
    }
  })

  const onSubmit = async value => {
    value.phone = value.phone.replace(/^(\+)|\D/g, '$1')
    value = { ...value, user_id: userInfo.user_id }
    await patchUser(value)
    reset()
    setShowModal(false)
    getUser()
    
  }

  return (
    <Modal
      autoHeight
      show={showModal}
      handleClose={() => setShowModal(false)}
    >
      <div data-testid='updateUserModalContent' className='w100% h100% bgc-white bd2-s-input bxshmodal bdrs-4'>
        <div className='df jcsb'>
          <p className='fz16 ml16 fw600'>{'Update User'}</p>
          <button className='bdnone m0 bgc-t' onClick={() => setShowModal(false)}>
            <img src={clear} alt='cancel button' />
          </button>
        </div>
        <hr className='mt0 mb16 bdnone bt1-s-lightgray' />
        <div className='mih300 pl16 pr16 df fxdrr fxww' data-testid="tableStatusLoader" >
          <div className='w100% tal'>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className='df jcsb'>
                <div className='w45%'>
                  <label className='fz13'>First Name*</label>
                  <input
                    className='bd2-s-input mt4 mb10 fz15'
                    type="text"
                    name="first"
                    ref={register({ required: true })} />
                </div>
                <div className='w45%'>
                  <label className='fz13'>Last Name*</label>
                  <input
                    className='bd2-s-input mt4 mb10 fz15'
                    type="text"
                    name="last"
                    ref={register({ required: true })} />
                </div>
              </div>
              <div className='w45%'>
                <label className='fz13'>Phone*</label>
                <input
                  className='bd2-s-input mt4 mb15 fz15' 
                  type="text" 
                  name="phone"
                  ref={register({ required: true, pattern: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/  })} />
              </div>
              {((errors.phone  && errors.phone.type === 'required') || errors.first || errors.last) && (
                <p className='c-red-700 fz14 pb0 mb0'> All fields are required</p>
              )}
              {errors.phone && errors.phone.type === 'pattern' && (
                <p className='c-red-700 fz14 mt10 p0'>Please provide a valid phone number <br />ex. 919-999-9999, limited to 10 digits</p>
              )}

            </form>
          </div>
        </div>
        <hr className='mt20 mb16 bdnone bt1-s-lightgray' />
        <div className='df jcfe'>
          <Button text='Cancel' customClassName='mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4' clickHandler={() => setShowModal(false)} />
          <Button type='success' text='Update User' clickHandler={handleSubmit(onSubmit)} customClassName=' mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4'/>
        </div>
      </div>
    </Modal>
  )
}

export default UpdateUserForm